import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { KeyboardShortcutsService } from './services/keyboard-shortcuts.service';
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';

@Component({
	selector: 'app-root',
	template: `
		<ng-keyboard-shortcuts [shortcuts]="shortcutsService.shortcuts"></ng-keyboard-shortcuts>
		<router-outlet></router-outlet>
	`,
	imports: [RouterModule, KeyboardShortcutsModule],
})
export class AppComponent {
	protected readonly shortcutsService = inject(KeyboardShortcutsService);
}
